// TODO: for wishlist extraction, move this out of ecom-common
export const sizeGuideActions = {
  FETCH_SIZE_GUIDE_SUCCESS: "FETCH_SIZE_GUIDE_SUCCESS",
};

export function setSizeGuide(productId, sizeGuide) {
  return {
    type: sizeGuideActions.FETCH_SIZE_GUIDE_SUCCESS,
    payload: {
      sizeGuide,
      productId,
    },
  };
}
